{
  "actionText": "#C4B5FD"
}
